import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useSEO } from "../hooks/useSEO";

export default function PaymentCancel() {
  useSEO("Payment Cancelled | NAKSRA", "Your NAKSRA payment was cancelled.");

  return (
    <div className="min-h-screen bg-[#050507] text-[#F8F9FA]">
      <Navbar />
      <main className="mx-auto max-w-2xl px-6 py-32 text-center" data-testid="payment-cancel-page">
        <XCircle className="mx-auto h-12 w-12 text-[#A1A1AA]" />
        <h1 className="mt-6 font-heading text-4xl font-medium tracking-tight sm:text-5xl">Payment cancelled</h1>
        <p className="mt-6 leading-relaxed text-[#A1A1AA]">
          No charge was made. Your birth details were saved as a draft order — you can complete the payment whenever you're ready.
        </p>
        <div className="mt-10 flex justify-center gap-4">
          <Link to="/services" data-testid="cancel-services-cta" className="rounded-full bg-[#D4AF37] px-8 py-3 text-sm font-semibold text-black transition-colors duration-300 hover:bg-[#FBE18D] active:scale-[0.98]">
            Back to reports
          </Link>
          <Link to="/" data-testid="cancel-home-cta" className="rounded-full border border-white/20 px-8 py-3 text-sm font-medium text-white transition-colors duration-300 hover:bg-white/5">
            Home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
